---
fr:
  admin:
    power_plants:
      delete_data:
        confirm_hint: Action irréversible. Saisissez le nom de la centrale « {name} » pour confirmer.
        confirm_label: Nom de la centrale
        counts:
          downtime_days: Jours d'arrêt
          downtime_events: Événements d'arrêt
          downtime_periods: Heures d'arrêt
          orphaned_downtime_events: Événements d'arrêt laissés incomplets
          production_days: Jours de production
          production_periods: Périodes de production
          production_quarters: Quarts d'heure de production
          revenue_periods: Périodes de revenus
          verified_downtime_events: Événements d'arrêt vérifiés
        delete: Supprimer les données
        deleted_body: "{count} lignes supprimées."
        deleted_title: Données de production supprimées
        deleting: Suppression en cours. Ne fermez pas cette fenêtre avant la fin.
        description: Supprime définitivement les données de production et d'arrêt de cette centrale sur la période sélectionnée. Prévisualisez l'impact, puis confirmez.
        error: Une erreur est survenue. Aucune donnée n'a été supprimée.
        errors:
          busy: Une autre tâche écrit les données de production de cette centrale. Rien n’a été supprimé — réessayez dans quelques minutes.
        from: Du
        menu: Supprimer les données de production
        preview: Prévisualiser l'impact
        rows_header: Lignes à supprimer
        table_header: Données
        title: 'Supprimer les données de production : {name}'
        to: Au
        verified_blocked: La période chevauche des événements d'arrêt vérifiés, la suppression est donc refusée. Retirez leur vérification ou réduisez la période.
